module.exports = __webpack_public_path__ + "/img/Chip-6Vp2dT.svg";